import type { SavedFlightSnapshot } from "@/shared/api/aviabooking"
import { formatFlightWallTime } from "@/shared/lib/flight-wall-time"

export const formatSegmentFlightNumber = (airline: string, flightNumber: string) =>
    flightNumber.toUpperCase().startsWith(airline.toUpperCase()) ? flightNumber : `${airline} ${flightNumber}`

export function FlightItinerary({ snapshot }: { snapshot: SavedFlightSnapshot }) {
    return <div className="flex flex-col gap-3">
        <p>{snapshot.dep_airport_code} → {snapshot.arr_airport_code} · В пути {snapshot.total_duration} мин.</p>
        <ol className="flex flex-col gap-3">
            {snapshot.segments.map((segment, index) => <li key={index} className="border rounded-xl p-3">
                <p>{formatSegmentFlightNumber(segment.marketing_airline, segment.flight_number)}{segment.op_airline && segment.op_airline !== segment.marketing_airline ? ` · выполняет ${segment.op_airline}` : ""}</p>
                <p>{segment.dep_airport_code} · {formatFlightWallTime(segment.dep_date_time)} → {segment.arr_airport_code} · {formatFlightWallTime(segment.arr_date_time)}</p>
                {segment.aircraft_type && <p>Самолёт: {segment.aircraft_type}</p>}
            </li>)}
        </ol>
        <p className="font-bold">Цена: {snapshot.price.amount} {snapshot.price.currency}</p>
        {snapshot.price.validating_company && <p>Оформляющая авиакомпания: {snapshot.price.validating_company}</p>}
    </div>
}
